module.exports = __webpack_public_path__ + "img/white05_128.3510b4a9.png";